export default __webpack_public_path__ + "static/media/kwid-colour-6.f1a60033.jpg";